import { FormEvent, useMemo, useState } from 'react';

type Msg = { role: 'user' | 'bot'; text: string };

const catalog: { keywords: string[]; response: string }[] = [
  {
    keywords: ['marketplace', 'extension', 'espo', 'theme', 'enum', 'list view', 'shop', 'buy'],
    response:
      'Bizi Marketplace is our digital storefront for EspoCRM extensions — published live from Bizi Office CRM. Browse /marketplace anytime. Each purchase unlocks a secure one-time download after Stripe™ checkout.',
  },
  {
    keywords: ['service', 'what do', 'what can', 'help', 'offer', 'provide'],
    response:
      'Bizi Office builds custom AI & automation: email triage, support bots, data entry, calendar ops, sales follow-up, and workflow glue. We’re your automation partner — not a one-size SaaS box.',
  },
  {
    keywords: ['price', 'cost', 'pricing', 'how much', 'budget'],
    response:
      'Custom automation is scoped after a free consult. Marketplace extensions have clear sticker prices on each product page. Most service clients see ROI inside 60 days.',
  },
  {
    keywords: ['process', 'how does', 'start', 'begin', 'get started'],
    response:
      '1) Discovery call  2) Process audit  3) Custom strategy  4) Build & implement  5) Train & support. Want the fast lane? Grab an extension on Bizi Marketplace or book a consult below.',
  },
  {
    keywords: ['consult', 'schedule', 'meeting', 'call', 'contact', 'talk'],
    response:
      'You bet. Scroll to Contact, send your name + email + biggest time-waster, and the team will follow up within one business day. Or open Marketplace if you already know which extension you need.',
  },
];

function replyFor(input: string): string {
  const lower = input.toLowerCase();
  for (const item of catalog) {
    if (item.keywords.some((k) => lower.includes(k))) return item.response;
  }
  return 'Appreciatecha for asking! I can help with services, pricing, our process, consultations, or Bizi Marketplace extensions. What are you aiming to automate?';
}

export function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState<Msg[]>([
    {
      role: 'bot',
      text: "Hi! I'm Henry. I can help you explore automation, book a consult, or find the right EspoCRM extension on Bizi Marketplace.",
    },
  ]);

  const flit = useMemo(() => 'https://imgs.bizioffice.com/website/Flit%20Trans.png', []);

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    const text = input.trim();
    if (!text) return;
    setMessages((m) => [...m, { role: 'user', text }, { role: 'bot', text: replyFor(text) }]);
    setInput('');
  }

  return (
    <div className={`chat-widget ${open ? 'open' : ''}`}>
      <div className="chat-window" role="dialog" aria-label="Chat with Bizi Office">
        <div className="chat-header">
          <img src={flit} alt="" className="chat-avatar" />
          <div className="chat-header-text">
            <h3>Chat with Bizi Office</h3>
            <p>Automation + Marketplace help</p>
          </div>
          <button className="chat-close" aria-label="Close chat" onClick={() => setOpen(false)}>
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>
        <div className="chat-messages">
          {messages.map((m, i) => (
            <div key={i} className={`message ${m.role}`}>
              {m.role === 'bot' && <img src={flit} alt="" className="bot-avatar" />}
              <div className="bubble">{m.text}</div>
            </div>
          ))}
        </div>
        <form className="chat-input-form" onSubmit={onSubmit}>
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Ask about automation or Marketplace..."
            aria-label="Chat message"
          />
          <button type="submit" aria-label="Send">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="22" y1="2" x2="11" y2="13" />
              <polygon points="22 2 15 22 11 13 2 9 22 2" />
            </svg>
          </button>
        </form>
      </div>
      <button className="chat-toggle" aria-label="Open chat" onClick={() => setOpen((v) => !v)}>
        {open ? (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
          </svg>
        )}
      </button>
    </div>
  );
}
